import { useEffect } from 'react';
import { SITE } from '../data/site';

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

export default function SEO({ title, description, path = '/', schemas = [] }) {
  const schemasKey = JSON.stringify(schemas);

  useEffect(() => {
    document.title = title;

    const meta = (attr, key) => upsert(`meta[${attr}="${key}"]`, () => {
      const m = document.createElement('meta');
      m.setAttribute(attr, key);
      return m;
    });

    meta('name', 'description').setAttribute('content', description);
    meta('property', 'og:title').setAttribute('content', title);
    meta('property', 'og:description').setAttribute('content', description);
    meta('property', 'og:type').setAttribute('content', 'website');
    meta('property', 'og:url').setAttribute('content', `${SITE.domain}${path}`);
    meta('name', 'twitter:card').setAttribute('content', 'summary_large_image');

    upsert('link[rel="canonical"]', () => {
      const l = document.createElement('link');
      l.setAttribute('rel', 'canonical');
      return l;
    }).setAttribute('href', `${SITE.domain}${path}`);

    const injected = schemas.map((schema) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.dataset.seoInjected = '1';
      s.text = JSON.stringify(schema);
      document.head.appendChild(s);
      return s;
    });

    return () => injected.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, schemasKey]);

  return null;
}
